import { BettingType } from "../../lookups";
import { Key } from "../Key";

export class EventKey extends Key {
    eventId: string;
    bettingType: BettingType;
    isAlternate?: boolean;
}